<template>
  <el-main>
    <div class="top-wrap">
      <Bread></Bread>
    </div>
    <div class="main mb0">
      <div class="plate">
        <div class="title2">修改商品信息</div>
      </div>
    </div>
    <div class="main mt0">
      <el-table :data="tableData" style="width: 100%; margin-top: 10px">
        <el-table-column
          prop="goodsImg"
          label="商品图片"
          min-width="8%"
          align="center"
        >
          <template slot-scope="{ row }">
            <div>
              <el-image
                style="width: 80px; height: 80px"
                :src="row.goodsImg"
              ></el-image>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="goodsName"
          label="商品名称"
          min-width="8%"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="goodsPrice"
          label="现价"
          min-width="8%"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="price"
          label="修改后价格"
          min-width="8%"
          align="center"
        >
          <template slot-scope="scope">
            <div>
              <el-input
                v-model="scope.row.price"
                size="medium"
                oninput="value=value.replace(/[^0-9]/g,'')"
              >
              </el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="goodsAttribute"
          label="属性"
          min-width="8%"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="goodsNum"
          label="数量"
          min-width="8%"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.goodsNum"
              size="medium"
              oninput="value=value.replace(/[^0-9]/g,'')"
            >
            </el-input>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="goodsNum"
          label="库存"
          min-width="8%"
          align="center"
        ></el-table-column> -->
        <el-table-column
          prop="totalPay"
          label="小计"
          min-width="8%"
          align="center"
        ></el-table-column>
      </el-table>
      <div class="right_div">
        <div>
          <el-button type="info" @click="cancelProduct">取消</el-button>
          <el-button type="primary" @click="submitProduct">确认</el-button>
        </div>
      </div>
    </div>
  </el-main>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      //表格部分
      tableData: [
        {
          goodsImg: "../../../assets/empty.png",
          goodsName: "皮蛋瘦肉粥",
          goodsPrice: "10",
          price: "8.00",
          goodsAttribute: "含金量500ml 毒性:五毒",
          goodsNum: "10",
          // goodsNum: "20",
          totalPay: "8",
        },
      ],
      orderId: "",
    };
  },
  mounted() {
    this.orderId = this.$route.query.orderId;
  },
  created() {
    this.tableData = JSON.parse(sessionStorage.getItem("infoGoods"));
  },
  methods: {
    // 取消
    cancelProduct() {
      this.$router.go(-1);
    },
    // 修改商品提交
    submitProduct() {
      this.$http.szOrder
        .editGoods({
          orderId: this.orderId,
          goodsNum: this.tableData[0].goodsNum,
          price: this.tableData[0].price,
        })
        .then((res) => {
          if (res.status == 1) {
            this.stepLoading = false;
            this.$message({
              message: "修改成功",
              type: "success",
            });
            this.$router.go(-1);
            setTimeout(() => {
              this.stepLoading = false;
            }, 1000);
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.plate {
  .title {
    font-size: 18px;
    color: #333333;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    font-weight: bold;

    label {
      font-size: 16px;
      color: #999999;
    }

    &:before {
      content: "";
      display: inline-block;
      width: 5px;
      height: 18px;
      background: #018388;
      border-radius: 3px;
      margin-right: 5px;
    }
  }
}

.el-input--medium {
  width: 100px;
}

.right_div {
  margin-top: 60px;

  div {
    text-align: center;

    .el-button {
      width: 120px;
    }
  }
}

.mb0 {
  margin-bottom: 0;
  border-bottom: 1px solid #e9ebee;
}

::v-deep .mt0 {
  margin-top: 0 !important;
}

.title2 {
  font-size: 18px;
  color: #018388;
  display: flex;
  align-items: center;
  font-weight: bold;

  label {
    font-size: 16px;
    color: #999999;
  }

  // &:before {
  //     content: "";
  //     display: inline-block;
  //     width: 5px;
  //     height: 18px;
  //     background: #018388;
  //     border-radius: 3px;
  //     margin-right: 5px;
  // }
}

.layout .el-container .el-main .main {
  flex: none;
  padding: 10px 16px 16px;
  margin: 16px 16px 0;
  background: #fff;
}
</style>
